// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"670":"3d11b35b","680":"56e0bf90","993":"20c2c565"}[chunkId] + ".chunk.js";
};